var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-container page-header-component"},[_c('div',{staticClass:"pl-0 col-12 mb-2 pb-2 clearfix"},[_c('h6',{staticClass:"float-left"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tool-items float-left ml-5 text-right"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }